var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.143 4.93695C23.308 5.30695 22.411 5.55696 21.468 5.66996C22.441 5.08775 23.169 4.17142 23.516 3.09195C22.6019 3.63494 21.6014 4.01715 20.558 4.22196C19.8564 3.47282 18.9271 2.97628 17.9143 2.80943C16.9016 2.64258 15.8621 2.81475 14.9572 3.29921C14.0524 3.78367 13.3328 4.55332 12.9102 5.48866C12.4875 6.424 12.3855 7.4727 12.62 8.47195C10.7677 8.37895 8.95564 7.8975 7.30144 7.05886C5.64723 6.22022 4.18785 5.04312 3.01801 3.60396C2.61801 4.29396 2.38801 5.09396 2.38801 5.94596C2.38757 6.71295 2.57644 7.4682 2.93789 8.14469C3.29934 8.82118 3.82217 9.39799 4.46001 9.82396C3.72029 9.80042 2.99688 9.60054 2.35001 9.24095V9.30095C2.34994 10.3767 2.72204 11.4193 3.40319 12.252C4.08434 13.0846 5.03258 13.6559 6.08701 13.869C5.4008 14.0547 4.68135 14.082 3.98301 13.949C4.28051 14.8746 4.86001 15.684 5.64038 16.2639C6.42075 16.8438 7.36293 17.1651 8.33501 17.183C6.68484 18.4784 4.6469 19.181 2.54901 19.178C2.17739 19.1781 1.80609 19.1564 1.43701 19.113C3.56649 20.4821 6.04535 21.2088 8.57701 21.206C17.147 21.206 21.832 14.108 21.832 7.95195C21.832 7.75196 21.827 7.54995 21.818 7.34995C22.7293 6.69093 23.5159 5.87485 24.141 4.93995L24.143 4.93695Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social-twitter.e6cfc0a35919797c083e11cb976c7ec3.svg";
export { ForwardRef as ReactComponent };